import * as React from 'react'
import { Link } from 'react-router-dom'
import {
  IMap,
  ITripAvailableProduct,
  IRiderObject,
  ITripRequestObject,
  IServicePricingType,
  IPaymentMethods,
  ITripPassengerDetail
} from '../../../types'
import TripServiceProductList from '../../../containers/trips/services/TripServiceProductList'
import { CreateTripContext } from '../CreateTrip'
import PSTA from '../../icons/provider/PSTA'
import Arrow from '../../icons/ui/Arrow'
import Exclamation from '../../icons/ui/Exclamation'
import ImageView from '../../ui/ImageView'
import { convertCentsToDollars } from '../../../utils'
import moment from 'moment'

export interface ITripServiceListProps {
  riderServiceProducts: ITripAvailableProduct[]
  riderId: string
  rider: IRiderObject
  tripRequest: ITripRequestObject
  servicePricing: IServicePricingType[]
  fetchServicePricingType: (serviceId: string) => void
  fetchPaymentMethods: (serviceId: string) => Promise<IPaymentMethods[]>
  setTripPassengerDetails: (passengerDetails: ITripPassengerDetail) => void
  updateRiderCount: (totalRider: number) => void
}

export default class TripServiceList extends React.Component<ITripServiceListProps> {
  public componentDidUpdate(prevProps: ITripServiceListProps) {
    if (this.props.tripRequest.currentServiceId !== prevProps.tripRequest.currentServiceId) {
      this.props.fetchServicePricingType(this.props.tripRequest.currentServiceId!)
      this.props.fetchPaymentMethods(this.props.tripRequest.currentServiceId!).then(result => {
        const filteredPaymntMethods = result.filter(r => r.activated)
        const fareType = filteredPaymntMethods.length ? filteredPaymntMethods[0].paymentName : null

        this.props.setTripPassengerDetails({
          tripRequestRiders: [{ fareType, riderType: 'Adult', totalRider: 1, amount: 0, totalAmount: 0 }],
          attendant: false,
          disabilityApproved: false
        })
      })
      this.props.updateRiderCount(1)
    }
  }

  public render() {
    const commentStyle = {
      fontSize: '9pt',
      lineHeight: '0.9rem',
      display: 'inline-block'
    }
    const services = {}

    this.props.riderServiceProducts.forEach(rsp => {
      if (!services[rsp.serviceId]) {
        services[rsp.serviceId] = {
          id: rsp.serviceId,
          name: rsp.serviceName,
          riderHasMembership: rsp.riderHasMembership,
          serviceMembershipRequired: rsp.serviceMembershipRequired,
          serviceBeginsAt: rsp.serviceBeginsAt,
          serviceExpiresAt: rsp.serviceExpiresAt,
          serviceType: rsp.serviceType,
          viewOption: rsp.viewOption,
          products: [rsp]
        }
      } else {
        services[rsp.serviceId].products.push(rsp)
      }
    })

    return (
      <div>
        {Object.keys(services).map(skey => {
          const service = services[skey]
          const expiryDate = moment(service.serviceExpiresAt)
          if (expiryDate < moment() && service.serviceType !== 'PERMANENT') {
            return (
              <div key={`expired-trip-service-${service.id}`} className='red-font'>
                {service.name} membership expired: {expiryDate.format('MM/DD/YYYY')}
              </div>
            )
          }
          return (
            <TripServiceListItem
              key={`trip-service-${service.id}`}
              riderServiceProducts={service.products}
              serviceId={service.id}
              serviceName={service.name}
              serviceMembershipRequired={service.serviceMembershipRequired}
              riderHasMembership={service.riderHasMembership}
              viewOption={service.viewOption}
              riderId={this.props.riderId}
            />
          )
        })}
        {this.props.riderServiceProducts.length === 0 && (
          <div>
            <span className='p1 font-red h5 pl1 mb0 mt0'>No services in your area</span>
            <span className='font-grey2 pl1 mt0' style={commentStyle}>
              Services outside the current geo zone will not display. Please check your geo zone and membership
              settings.
            </span>
          </div>
        )}
      </div>
    )
  }
}

export interface ITripServiceListItemProps {
  serviceId: string
  riderServiceProducts: ITripAvailableProduct[]
  serviceName: string
  serviceMembershipRequired: boolean
  riderHasMembership: boolean
  viewOption: string
  riderId: string
}
export interface ITripServiceListItemState {
  isOpen: boolean
}
class TripServiceListItem extends React.Component<ITripServiceListItemProps, any> {
  public state = {
    isOpen: true
  }

  public render() {
    const { isOpen } = this.state
    const {
      serviceId,
      serviceName,
      riderServiceProducts,
      serviceMembershipRequired,
      riderHasMembership,
      viewOption,
      riderId
    } = this.props

    const {
      promoLimit,
      promoTripCount,
      promoFare,
      completedTripCount,
      serviceTripLimit,
      promoDuration,
      serviceLimitDuration
    } = riderServiceProducts[0]

    const height = isOpen ? 'auto' : 0
    const transform = isOpen ? 'rotate(180deg)' : 'rotate(0deg)'
    return (
      <React.Fragment key={serviceId}>
        <div
          className='fit col-12 cursor--pointer mt1'
          onClick={this.handleShow}
          onKeyPress={e => e.key === 'Enter' && this.handleShow()}
          tabIndex={0}
          role='button'
          aria-expanded={isOpen}
        >
          <div className='bg-light-grey2 py1 px3 flex items-center'>
            <ImageView entityId={serviceId} width='30px' height='30px' />
            <span className='font-blue-grey uppercase h6 ml2 mr2 text-start'>{serviceName}</span>
            {!serviceMembershipRequired ? (
              <span className='font-green h6'>Free Membership</span>
            ) : riderHasMembership ? (
              <span className='font-blue h6'>Member</span>
            ) : (
              <Link className='block center' to={`/riders/${riderId}/edit/membership`}>
                <span className='font-red h6'> Membership Required</span>
              </Link>
            )}
          </div>
          {promoLimit > promoTripCount && (
            <div className='bg-light-grey2 pb1 col-12 flex items-center h5 justify-center'>
              {promoTripCount} of {promoLimit} Promo fare of ${convertCentsToDollars(promoFare)} per {promoDuration}
            </div>
          )}
          {serviceTripLimit === 0 && <div className='bg-light-grey2 pb1 col-12 flex items-center h5 justify-center' />}
          {serviceTripLimit >= completedTripCount &&
            serviceTripLimit > 0 &&
            riderServiceProducts[0].name !== 'noProduct' && (
              <div className='bg-light-grey2 pb1 col-12 flex items-center h5 justify-center'>
                {completedTripCount} of {serviceTripLimit} trips taken per {serviceLimitDuration}
              </div>
            )}
        </div>
        {riderServiceProducts[0].name === 'noProduct' && serviceTripLimit > 0 && (
          <div className='bg-light-grey2 pb1 col-12 flex items-center h5 justify-center'>
            {serviceTripLimit} trips allowed for this service
          </div>
        )}
        <div className='overflow-hidden service-product-list' style={{ height }}>
          {riderServiceProducts[0].name !== 'noProduct' && (
            <TripServiceProductList products={riderServiceProducts} riderId={riderId} />
          )}
        </div>
      </React.Fragment>
    )
  }

  private handleShow = () => {
    this.setState({ isOpen: true })
  }
}



// WEBPACK FOOTER //
// ./src/components/trips/services/TripServiceList.tsx